/*! @azure/msal-react v2.0.8 2023-12-01 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-react";
const version = "2.0.8";

export { name, version };
//# sourceMappingURL=packageMetadata.js.map
